import { base } from './';
import { IOrganization } from 'types';

const PATH = '/platform/organizations';

const getAll = () => base.get<IOrganization[]>(PATH);
const get = (id: number) => base.get<IOrganization>(`${PATH}/${id}`);
const post = (data: Partial<IOrganization>) => base.post(PATH, data);
const put = (id: number, data: Partial<IOrganization>) =>
  base.patch(`${PATH}/${id}`, data);
const del = (id: number) => base.delete(`${PATH}/${id}`);

export { getAll, get, post, put, del };
